// Consistent parsing of the backend { success, error: { code, message, details } } envelope.
// `details` is a Record<string, string[]> keyed by field path (e.g. "allowedIps.1").

export function parseApiError(error, fallback = 'Something went wrong. Please try again.') {
  const e = error?.response?.data?.error;
  return {
    code: e?.code,
    message: e?.message || error?.message || fallback,
    details: e?.details || {},
  };
}

/** Flatten a details map into "field: message" lines for a banner. */
export function detailsToLines(details) {
  return Object.entries(details || {}).flatMap(([field, msgs]) =>
    (Array.isArray(msgs) ? msgs : [String(msgs)]).map((m) => `${field}: ${m}`)
  );
}

/** First message for a given field key (or undefined). */
export function fieldError(details, key) {
  const v = details?.[key];
  return Array.isArray(v) ? v[0] : v;
}
